import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';

import { safeContent } from '../../utils';

export default function Banner( props ) {
    const { blockKey = "", fileName, titleFr, subTitleFr, price, linkTextFr = "ACHETEZ ", linkUrl } = props.data;

    return (
        <div className={ `banner banner-overlay ${blockKey}` } style={{height: '290px'}}>
            <Link to="#" style={{height: '100%'}}>
                <div className="lazy-overlay bg-white"></div>
                <LazyLoadImage
                    src={ `${process.env.REACT_APP_API_URL}/uploads/banners/` + fileName }
                    width={ 100 }
                    height={ 290 }
                    effect="blur"
                />
            </Link>

            <div className={ `banner-content ${blockKey}` }>
                {
                    subTitleFr ?
                        <h4 className="banner-subtitle text-white d-none d-sm-block"><Link to="#">{ subTitleFr }</Link></h4>
                        : ""
                }

                {
                    titleFr ?
                        <h3 className="banner-title text-white"><Link to="#" dangerouslySetInnerHTML={ safeContent( titleFr ) }></Link></h3>
                        : ""
                }

                {
                    price ?
                        <div className="price text-center" dangerouslySetInnerHTML={ safeContent( price ) }></div>
                        : ""
                }

                <a href={ linkUrl } className="banner-link"  target="_blank">{ linkTextFr }<i className="icon-long-arrow-right"></i></a>
            </div>
        </div>
    );
}